<template>
  <iColumn
    align="center"
    gap="none"
  >
    <iRow
      vertical-align="middle"
      width="hug"
    >
      <iText>Powered by</iText>
    </iRow>
    <iRow
      vertical-align="middle"
      width="hug"
    >
      <Logo />
    </iRow>
  </iColumn>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
  name: "PoweredByInspiration",
  components: { Logo },
};
</script>
